import { Component, Prop, Vue } from "vue-property-decorator";
import { Module } from "@/store/enums.ts";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";

@Component
export default class BalliOutro extends Vue {
  render(h: CreateElement) {
    return (
      <Card>
        <div slot="mainContent" class="subtitle-1">
          You completed BALLI! Thank you for your hard work.
        </div>
        <div slot="actions">
          <v-btn color="primary" to="/home">
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(
              (this.$store.getters.progressBalli /
                this.$store.getters.numBalliQuestions) *
                100
            )}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }
}

const component = BalliOutro;
